/**
 * Device Type IDs - match the database values
 */
export const DeviceTypeId = {
  HOST: 1,
  CAMERA: 2,
  PLC: 3,
  ROBOT_ARM: 4,
  USB: 5,
  REST: 6,
  STEREO_CAMERA: 7,
} as const;

export type DeviceTypeId = (typeof DeviceTypeId)[keyof typeof DeviceTypeId];

/**
 * Device type colors for chips/badges
 */
export const DeviceTypeColors: Record<number, { bg: string; border: string; text: string }> = {
  [DeviceTypeId.HOST]: { bg: 'rgba(83, 189, 228, 0.2)', border: '#53bde4', text: '#53bde4' },
  [DeviceTypeId.CAMERA]: { bg: 'rgba(156, 39, 176, 0.2)', border: '#9c27b0', text: '#ce93d8' },
  [DeviceTypeId.PLC]: { bg: 'rgba(255, 152, 0, 0.2)', border: '#ff9800', text: '#ffb74d' },
  [DeviceTypeId.ROBOT_ARM]: { bg: 'rgba(76, 175, 80, 0.2)', border: '#4caf50', text: '#81c784' },
  [DeviceTypeId.USB]: { bg: 'rgba(233, 30, 99, 0.2)', border: '#e91e63', text: '#f48fb1' },
  [DeviceTypeId.REST]: { bg: 'rgba(0, 188, 212, 0.2)', border: '#00bcd4', text: '#4dd0e1' },
  [DeviceTypeId.STEREO_CAMERA]: { bg: 'rgba(103, 58, 183, 0.2)', border: '#673ab7', text: '#b39ddb' },
};

/**
 * Get color scheme for a device type
 */
export function getDeviceTypeColor(typeId: number) {
  return DeviceTypeColors[typeId] || { bg: 'rgba(158, 158, 158, 0.2)', border: '#9e9e9e', text: '#bdbdbd' };
}
